<ng-content select="ig-drop-down-trigger"></ng-content>

<div #dropDownContainer class="drop-down-container" #container
     [class.show]="isShowing">
    <ng-content select="[items]"></ng-content>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/drop.down/drop.down.component.html